import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { schemeUrlFor } from "../pages/OpenApp";

/**
 * Goes to /app on this same site. Not configurable, and deliberately not an
 * absolute URL on some other host.
 *
 * What this does and does not do. /app is claimed by the app in
 * public/.well-known/apple-app-site-association, so the OS opens the app for
 * anyone who follows that link from ANYWHERE ELSE — a message, an email, a
 * search result. It will not do that for this button, because iOS never hands
 * a Universal Link to the app when the tap happened on a page served by that
 * link's own host, and this button is on that host. That is an anti-hijacking
 * rule with no web-side workaround.
 *
 * So this button opens the app through the custom URL scheme, which carries no
 * same-host rule, and still reaches /app for the store fallback. Pointing the
 * target at another host to "fix" the Universal Link is the change this comment
 * exists to prevent.
 *
 * The scheme is fired here rather than on arrival at /app because here is
 * inside the tap. A navigation a browser can trace to a gesture is one it never
 * second-guesses; the same navigation from an effect one tick later is at the
 * mercy of a popup heuristic, and losing that bet is a button that does nothing
 * on a phone that has the app.
 */
const OpenInApp = ({ className = "btn" }: { className?: string }) => {
  const { t } = useTranslation();
  const scheme = schemeUrlFor(navigator.userAgent, navigator.maxTouchPoints);

  return (
    <Link
      className={className}
      to="/app"
      // Only claimed when it is true. /app reads this to decide whether to fire
      // the scheme itself, and it still owns the store fallback either way.
      state={scheme ? { schemeFired: true } : undefined}
      onClick={() => {
        if (scheme) window.location.href = scheme;
      }}
    >
      {t("openApp.button")}
    </Link>
  );
};

export default OpenInApp;
